import elementFlowTypes from '../constants/element-flow-types';

const hasFlexHorizontalFlowType = (elementStyle) => {
  if (!elementStyle) {
    return false;
  }

  const { display, flexDirection, flexBasis } = elementStyle;

  return (
    display === 'flex' &&
    (flexDirection === 'row' || flexDirection === 'row-reverse') &&
    flexBasis !== '100%'
  );
};

const hasGridHorizontalFlowType = (elementStyle) => {
  if (!elementStyle || !elementStyle.gridTemplateColumns) {
    return false;
  }

  const { display, gridTemplateColumns } = elementStyle;
  const hasMoreThanOneColumn = gridTemplateColumns.split(' ').length > 1;

  return display === 'grid' && hasMoreThanOneColumn;
};

const getElementFlowType = (element) => {
  const frameWindow = element.ownerDocument.defaultView;
  if (!frameWindow) return null;

  const container = element.parentElement;
  const elementStyle = frameWindow.getComputedStyle(element);
  const containerStyle = frameWindow.getComputedStyle(container);

  if (
    elementStyle.display === 'inline' ||
    elementStyle.display === 'inline-block' ||
    elementStyle.float === 'left' ||
    elementStyle.float === 'right' ||
    hasFlexHorizontalFlowType(containerStyle) ||
    hasGridHorizontalFlowType(containerStyle)
  ) {
    // In case if element occupies more than a half of containers' width we should render <DropGuide /> horizontally
    if (element.getBoundingClientRect().width > container.clientWidth * 0.5) {
      return elementFlowTypes.VERTICAL;
    }

    return elementFlowTypes.HORIZONTAL;
  }

  return elementFlowTypes.VERTICAL;
};

export default getElementFlowType;
